<fury-backdrop #backdrop="furyBackdrop"></fury-backdrop>
<!-- <fury-config-panel-toggle (openConfig)="openConfigPanel()"></fury-config-panel-toggle> -->

<!-- QUICKPANEL -->
<!-- <fury-sidebar #configPanel="furySidebar" [backdrop]="backdrop" [invisibleBackdrop]="true" position="right">
<fury-config-panel></fury-config-panel>
</fury-sidebar> -->
<!-- END QUICKPANEL -->

<div class="container" fxLayout="column">
  @if ((toolbarPosition$ | async) === 'above-fixed') {
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  }

  <mat-sidenav-container autosize fxFlex>

    <!-- SIDENAV -->
    @if (sideNavigation$ | async) {
      <mat-sidenav (closedStart)="closeSidenav()" (openedStart)="openSidenav()" [mode]="sidenavMode$ | async"
        [opened]="sidenavOpen$ | async" class="fury-collapsable-sidenav">
        <fury-sidenav (messageEvent)="receiveMessage($event)" [collapsed]="sidenavCollapsed$ | async" [expanded]="sidenavExpanded$ | async"></fury-sidenav>
      </mat-sidenav>
    }
    <!-- END SIDENAV -->

    <!-- <mat-sidenav [(opened)]="quickPanelOpen" mode="over" position="end">
    <fury-quickpanel></fury-quickpanel>
  </mat-sidenav> -->
  <mat-sidenav-content class="content-container" fxLayout="column">
    @if ((toolbarPosition$ | async) === 'fixed') {
      <ng-container *ngTemplateOutlet="toolbar"></ng-container>
    }
    <!-- {{ sidenavService.jipEnabled$ | async }} -->
    <!-- CONTENT -->
    <div [class.scroll-disabled]="scrollDisabled$ | async" cdkScrollable class="content" fxFlex="auto"
      fxLayout="column">
      @if ((toolbarPosition$ | async) === 'static') {
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      }

      <div class="content-inner" fxFlex="auto">
        <router-outlet></router-outlet>
      </div>

      @if (((footerPosition$ | async) === 'static') && !(footerDisabled$ | async)) {
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      }
    </div>
    <!-- END CONTENT -->

    @if (((footerPosition$ | async) === 'fixed') && !(footerDisabled$ | async)) {
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    }
  </mat-sidenav-content>
</mat-sidenav-container>

@if (((footerPosition$ | async) === 'above-fixed') && !(footerDisabled$ | async)) {
  <ng-container *ngTemplateOutlet="footer"></ng-container>
}
</div>

<ng-template #toolbar>
  <!-- TOOLBAR -->
  @if (toolbarVisible$ | async) {
    <fury-toolbar (openQuickPanel)="openQuickPanel()" [hasNavigation]="topNavigation$ | async"
    (openSidenav)="openSidenav()" fxFlex="none"></fury-toolbar>
  }
  <!-- END TOOLBAR -->

  <!-- NAVIGATION -->
  @if (topNavigation$ | async) {
    <fury-navigation fxFlex="none"></fury-navigation>
  }
  <!-- END NAVIGATION -->
</ng-template>

<!-- FOOTER -->
<ng-template #footer>
  <fury-footer fxFlex="none"></fury-footer>
</ng-template>
<!-- END FOOTER -->